// extracted by mini-css-extract-plugin
module.exports = {"title":"Post_title__KLtBC","url":"Post_url__1fyON","readAll":"Post_readAll__2QPT9","body":"Post_body__2hQWz","footer":"Post_footer__3LVjF"};